// Whether the planner and the flyover load on demand, as the server chose for this page (the
// lazy-app-loading meta tag; see LazyAppLoadingHelper). When it says off, the layout loads each one
// as its own entrypoint instead, so the on-demand path must stand down or the app would mount twice.
//
// A page whose layout doesn't render the tag also renders no static entrypoints, so it takes the
// on-demand path rather than ending up with neither.
export function lazyAppLoadingEnabled(doc: Document = document): boolean {
  return doc.querySelector<HTMLMetaElement>('meta[name="lazy-app-loading"]')?.content !== 'off';
}
